import dialogTemplate from './scorecard-structure-columns-dialog.hbs'
import ScorecardStructureColumns from './scorecard-structure-columns'

var ScorecardStructureColumnsDialog = ScorecardStructureColumns.extend({

	events: {
		'submit': 'submit'
	},

	_template: function() {
		return dialogTemplate()
	},

	submit: function(e) {
		e.preventDefault()
		this.trigger('done', this.model)
	}

})

export default ScorecardStructureColumnsDialog

ScorecardStructureColumnsDialog.__filename__ = 'reports/wizard/scorecard-structure/scorecard-structure-columns-dialog.js'
